import { useEffect, useState } from 'react';
import { hasClinicScope } from '@/application/auth/clinicScope';
import { getClinics } from '@/infrastructure/http/metricsApi';
import { useAuth } from '@/presentation/contexts/useAuth';

/**
 * Mapa `tenantId -> nombre` de las clínicas del scope del usuario, para no mostrar
 * GUIDs (identificadores internos) en la UI. Si falla, queda vacío y el caller cae al id.
 */
export function useClinicNames(): Record<string, string> {
  const { token, user } = useAuth();
  const [names, setNames] = useState<Record<string, string>>({});
  const clinicIdsKey = (user?.scope.allowedTenantIds ?? []).join('|');

  useEffect(() => {
    let cancelled = false;
    if (!token || !hasClinicScope(clinicIdsKey.split('|'))) {
      setNames({});
      return;
    }
    getClinics(token)
      .then((clinics) => {
        if (!cancelled) {
          setNames(Object.fromEntries(clinics.map((clinic) => [clinic.tenantId, clinic.nombre])));
        }
      })
      .catch(() => {
        // Best-effort: si no resuelve, el caller muestra el id.
      });
    return () => {
      cancelled = true;
    };
  }, [token, clinicIdsKey]);

  return names;
}
